// car location entry page
import { useState, useRef, useEffect } from 'react';
import styles from '../css/ticketEntry.module.css';
import { serverURL } from '../helpers/dataServerURL';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import blockingSpaces from '../jsonFIles/blockingSpaces.json';
import { FaCircle } from 'react-icons/fa';

export default function LocationEntry({ closeModal }) {
  // const [sectionName, setSectionName] = useState('');
  const [laneNumber, setLaneNumber] = useState('');
  const [spotNumber, setSpotNumber] = useState('');
  const [occupiedSpots, setOccupiedSpots] = useState([]);
  const [ticketsInOccupiedSpace, setTicketsInOccupiedSpace] = useState([]);
  const spaceRef = useRef([]);
  const ticketRef = useRef([]);
  const carRef = useRef([]);
  const carColorRef = useRef([]);
  const navigate = useNavigate();
  const location = useLocation();
  const [lanesInSectionCount, setLanesInSectionCount] = useState(0);
  const [lanesStartNum, setLanesStartNum] = useState(0);
  const [spacesInLaneCount, setSpacesInLaneCount] = useState(0);

  const logInURL = serverURL.server.url;

  // var lanesInSectionCount;
  // var laneStartNum;
  // let spaceNumArray = [];
  //
  useEffect(() => {
    // displayLanesInSection();
    listBlockingSpaces();
    displaySpacesInLane();
  }, [location.state.selectedSection]);

  function listBlockingSpaces() {
    const blocked = blockingSpaces.filter((space) => space.id >= 1 && space.id <= 6);
    return blocked;
  }
  const blockedSpaces = listBlockingSpaces();

  // function displaySpacesInLane() {
  //   console.log('blocked spaces2', location?.state?.selectedSection);
  //   lanesInSectionCount = 0;
  //   laneStartNum = 0;
  //   for (let i = 1; i <= blockedSpaces.length; i++) {
  //     if (location?.state?.selectedSection === blockedSpaces[i].SectionCaption) {
  //       console.log(
  //         'blocked spaces',
  //         blockedSpaces[i].SectionCaption,
  //         location?.state?.selectedSection === blockedSpaces[i].SectionCaption,
  //         location?.state?.selectedSection,
  //       );
  //       lanesInSectionCount = blockedSpaces[i].LastLaneNum;
  //       laneStartNum = blockedSpaces[i].FirstLaneNum - 1;
  //       console.log('lanes in section count', lanesInSectionCount, laneStartNum);
  //       return lanesInSectionCount;
  //     }
  //   }
  // }

  function displaySpacesInLane() {
    const section = blockedSpaces.find((space) => space.SectionCaption === location?.state?.selectedSection);

    if (!section) return;

    const laneCount = section.LastLaneNum - section.FirstLaneNum + 1;
    const laneStart = section.FirstLaneNum - 1;
    const spacesCount = section.LastSpaceNum;
    setLanesInSectionCount(laneCount);
    setLanesStartNum(laneStart);
    setSpacesInLaneCount(spacesCount);
  }

  // A function that identifies occupied spots in lane and section.
  // if spots are occupied, disable those spot buttons.
  async function identifyOccupiedSpots(section, lane) {
    // API call to get occupied spots for given section and lane
    try {
      const response = await axios.get(`${logInURL}/spaces/occupiedSpaces/${section}&${lane}`);
      if (response.data.length > 0) {
        const space = response.data.map((item) => item.SpaceNum);
        setOccupiedSpots(space);
        spaceRef.current = space;
        const ticket = response.data.map((t) => t.Ticket);
        setTicketsInOccupiedSpace(ticket);
        ticketRef.current = ticket;
        const car = response.data.map((c) => c.CarMake);
        carRef.current = car;
        const color = response.data.map((c) => c.CarColor);
        carColorRef.current = color;
        console.log(
          'Tickets in occupied spaces',
          ticketsInOccupiedSpace,
          occupiedSpots,
          ticketRef.current,
          spaceRef.current,
          carRef.current,
          carColorRef.current,
          response.data,
        );
      } else {
        setOccupiedSpots([]);
        spaceRef.current = [];
      }
    } catch (error) {
      console.error('Error fetching occupied spots:', error);
    }
  }

  // function displayLanesInSection() {
  //   if (location?.state?.selectedSection === 'A Lot N') {
  //     lanesInSectionCount = 19;
  //     laneStartNum = 0;
  //     return lanesInSectionCount;
  //   }
  //   if (location?.state?.selectedSection === 'A Lot S') {
  //     lanesInSectionCount = 20;
  //     laneStartNum = 19;
  //     return lanesInSectionCount;
  //   }
  //   if (location?.state?.selectedSection === 'B Lot W') {
  //     lanesInSectionCount = 27;
  //     laneStartNum = 22;
  //     return lanesInSectionCount;
  //   }
  //   if (location?.state?.selectedSection === 'B Lot E') {
  //     lanesInSectionCount = 22;
  //     laneStartNum = 0;
  //     return lanesInSectionCount;
  //   }
  //   if (location?.state?.selectedSection === 'B Lot M') {
  //     lanesInSectionCount = 5;
  //     laneStartNum = 0;
  //     return lanesInSectionCount;
  //   }
  //   if (location?.state?.selectedSection === 'Trailer Lot') {
  //     lanesInSectionCount = 21;
  //     laneStartNum = 49;
  //     return lanesInSectionCount;
  //   }
  // }

  function createLanes() {
    let lanes = [];
    for (let i = 1; i <= lanesInSectionCount; i++) {
      lanes.push(
        <div key={i}>
          <button
            className={styles.laneBtn}
            type="button"
            // eslint-disable-next-line no-loop-func
            onClick={async (e) => {
              setLaneNumber(i + lanesStartNum);
              console.log('lane number', i + lanesStartNum);
              // Do not navigate away from open modal if spot is not selected
              // Check to see how many spots are occupied in that lane.
              // Disable those spot buttons.
              identifyOccupiedSpots(location?.state?.selectedSection, i + lanesStartNum);
            }}
          >
            {/* {i <=
            lanesInSectionCount - 2
              ? `L ${i}`
              : `M ${i}`} */}
            L {i + lanesStartNum}
          </button>
        </div>,
      );
    }
    return lanes;
  }

  function createSpots() {
    let spots = [];
    for (let j = 1; j <= spacesInLaneCount; j++) {
      spots.push(
        <div
          key={j}
          style={{
            // backgroundColor:
            //   spaceRef.current && spaceRef.current.find((item) => item === j) ? '#b64316' : '#420738',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <button
            className={styles.laneBtn}
            style={
              spaceRef.current &&
              (spaceRef.current.find((item) => item === j)
                ? {
                    backgroundColor: '#1bb616ea',
                  }
                : {
                    backgroundColor: '#420738',
                  })
            }
            disabled={spaceRef.current && spaceRef.current.find((item) => item === j)}
            type="button"
            onClick={() => {
              if (laneNumber > 0) {
                navigate('/ticketEntry', {
                  state: {
                    selectedSpot: j,
                    selectedLane: laneNumber,
                  },
                });
                closeModal();
                setSpotNumber(j);
              } else {
                window.alert('Please select a lane first.');
              }
            }}
          >
            {spaceRef.current && spaceRef.current.find((item) => item === j) ? (
              <div>
                <div className={styles.spotCaptionDiv}>❌ Spot {j}</div>
                <div className={styles.spotCaptionDiv}>
                  🎫 {ticketRef.current[spaceRef.current.findIndex((i) => i === j)]}
                </div>
                <div className={styles.spotCaptionDiv}>
                  <span>🚕 {carRef.current[spaceRef.current.findIndex((i) => i === j)]}</span>
                  <span style={{ paddingLeft: '5px', paddingTop: '4px' }}>
                    <FaCircle size={14} color={carColorRef.current[spaceRef.current.findIndex((i) => i === j)]} />
                  </span>
                </div>
                {/* <div style={{ display: 'flex', flexDirection: 'row', whiteSpace: 'nowrap' }}>
                  🎨 {carColorRef.current[spaceRef.current.findIndex((i) => i === j)]}
                </div> */}
              </div>
            ) : (
              `Spot ${j} Open`
            )}
          </button>
        </div>,
      );
    }
    return spots;
  }
  return (
    <div>
      <div className={styles.headerContainer}>
        <h3 style={{ color: 'black' }}>Car Location Entry Page</h3>
        <div className={styles.inputContainer}>
          <input
            value={location?.state?.selectedSection}
            onChange={() => {}}
            placeholder="Section"
            required
            className={styles.locationInput}
            disabled
          />

          <input
            onChange={() => {}}
            value={`Lane: ${laneNumber}`}
            placeholder="Lane"
            required
            className={styles.locationInput}
            disabled
          />
          <input
            value={spotNumber}
            onChange={() => {}}
            placeholder="Spot"
            required
            className={styles.locationInput}
            disabled
          />
        </div>
      </div>

      <div className={styles.laneContainer}>{createLanes()}</div>
      {laneNumber > 0 && <div className={styles.spotContainer}>{createSpots()}</div>}
    </div>
  );
}
